import React from 'react'
import { Row, Col } from 'reactstrap'
import InstanceCard from './InstanceCard'
import InstancesToolbar from './InstancesToolbar'



function InstancesGrid({
  items,
  pageSize,
  onPageSizeChange,
  onRefresh,
  searchValue,
  onSearchChange,
  onSearch,
  onEdit,
  onToggleBlock,
  onDelete,
}) {
  const safeItems = Array.isArray(items) ? items : []

  return (
    <>
      <InstancesToolbar
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        onRefresh={onRefresh}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onSearch={onSearch}
      />
      <Row>
        {safeItems.map((item) => (
          <Col md="6" key={item.id}>
             <InstanceCard
              key={item.id}
              item={item}
              onEdit={onEdit}
              onToggleBlock={onToggleBlock}
              onDelete={onDelete}
            />
          </Col>
        ))}
      </Row>
    </>
  )
}

export default InstancesGrid
